export default __webpack_public_path__ + "static/media/color_dot.411f3a2b.svg";